<template>
  <v-checkbox
    :input-value="value"
    :label="label"
    :disabled="isDisabled"
    @change="handleCheck"
  />
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: null,
    },
    value: {
      type: Boolean,
      default: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleCheck(value) {
      this.$emit("input", value)
    },
  },
}
</script>
